module.exports = "https://s.pinimg.com/webapp/style/images/ios-icon-1x-80955526.png";